import { render } from "./ProsesKategori.vue?vue&type=template&id=7cea0dbf"
import script from "./ProsesKategori.vue?vue&type=script&lang=js"
export * from "./ProsesKategori.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__